export default {
  termsDescription: {
    id: 'insurances_options_annually_terms_description',
    defaultMessage:
      "I confirm I'm 18+. I'm signing up for minimum 1 year of Repair & Replace. After that, my plan renews automatically every year. I can cancel for a refund within 30 days of enrolment or within 30 days of each renewal.",
  },
  termsLinkContent: {
    id: 'insurances_options_annually_terms_link_content',
    defaultMessage: 'Terms and Conditions',
  },
}
